<template>
  <div v-if="isReady">
    <v-sheet outlined rounded class="px-4 py-2">
      <p class="lead">
        <span v-html="$t('customer_assessment_terms_ui.managed_at_parent')"/>
        <v-btn color="primary" outlined :href="'/customer/' + this.customer_id" class="ml-2">{{ this.customer.name }}</v-btn>
      </p>
      <v-row class="mt-2">
        <v-col sm="4">
          <h4>{{ $tc('cause', 2) }}</h4>
          <ul>
            <li v-for="(term, index) in causeTerms" :key="index">
              {{ term.value }}
              <b-badge class="ml-1" v-if="term.archived">{{ $t('archived') }}</b-badge>
            </li>
          </ul>
        </v-col>
        <v-col sm="4">
          <h4>{{ $tc('action', 2) }}</h4>
          <ul>
            <li v-for="(term, index) in actionTerms" :key="index">
              {{ term.value }}
              <v-badge v-if="term.archived" :content="$t('archived')"/>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
/**
 * This component is to facilitate displaying a customer's parent's customer assessment terms
 * when the customer itself has no terms.
 *
 * This is broken out into a separate component so we only request the details about the parent
 * customer if we need to, and to keep everything relevant to that tucked away from the rest of the
 * CustomerAssessmentTerm form.
*/

import { filter } from 'lodash'

export default {
  name: 'ParentAssessmentTerms',
  props: {
    customer_id: Number
  },
  data () {
    return {
      isReady: false,
      customer: null,
      customerAssessmentTerms: null
    }
  },
  methods: {
    fetchCustomer () {
      const customerPromise = this.$orm('Customer').find(this.customer_id)
        .then((customer) => {
          this.customer = customer
        })
      const termsPromise = this.$orm('CustomerAssessmentTerm').findAll({ customer_id: this.customer_id })
        .then(response => {
          this.customerAssessmentTerms = response.getItems()
        })

      Promise.all([customerPromise, termsPromise])
        .then(values => {
          this.isReady = true
        })
        .catch((error) => {
          if (error) {
            this.renderHttpAdapterErrorBanner(error)
            throw (error)
          }
        })
    }
  },
  mounted () {
    this.fetchCustomer()
  },
  computed: {
    causeTerms () {
      return filter(this.customerAssessmentTerms, x => x.type === 'cause')
    },
    actionTerms () {
      return filter(this.customerAssessmentTerms, x => x.type === 'action')
    }
  }
}
</script>

<style scoped>

</style>
